import { Injectable, NgZone } from '@angular/core';

import { StateEventMessage, StateSocketEnvelope } from '../models';
import { SupervisorCommunicationService } from '../../services/supervisor-communication.service';
import { ScopedWebSocketBaseService } from './scoped-websocket-base.service';

@Injectable({
  providedIn: 'root'
})
export class StateWebsocketService extends ScopedWebSocketBaseService {
  constructor(
    zone: NgZone,
    private readonly supervisorCommunicationService: SupervisorCommunicationService
  ) {
    super('State WS', zone);
  }

  protected buildUrl(userId: string, token: string): string {
    return this.buildDomainSocketUrl('StateManagement', userId, token);
  }

  protected handleParsedMessage(data: StateSocketEnvelope): void {
    if (!data || typeof data !== 'object') {
      return;
    }

    if (data.type === 'heartbeat') {
      return;
    }

    if (data.type !== 'data' || !data.payload || typeof data.payload !== 'object') {
      return;
    }

    const normalized = this.normalizePayload(data.payload, data.timestamp);
    if (normalized.role === 'agent') {
      this.supervisorCommunicationService.refreshStateAgent(normalized);
    }
  }

  private normalizePayload(payload: any, fallbackTimestamp?: string): StateEventMessage {
    const normalizedId = payload.agent_id ?? payload.id ?? payload._id ?? '';
    const normalizedTimestamp = payload.timestamp ?? fallbackTimestamp ?? new Date().toISOString();

    return {
      event_type: 'state_event',
      id: normalizedId,
      customId: payload.customId ?? payload.custom_id ?? null,
      email: payload.email ?? '',
      username: payload.username ?? '',
      version: payload.version ?? '',
      ip: payload.ip ?? '',
      lastUpdate: payload.lastUpdate ?? payload.last_update ?? normalizedTimestamp,
      createdAt: payload.createdAt ?? payload.created_at ?? normalizedTimestamp,
      role: payload.role ?? '',
      status: payload.status ?? '',
      campaigns: Array.isArray(payload.campaigns) ? payload.campaigns.map(String) : [],
      timestamp: normalizedTimestamp,
      agent_id: normalizedId,
      workspace_id: payload.workspace_id ?? null,
      campaign_id: payload.campaign_id ?? null,
      conversation_id: payload.conversation_id ?? null,
      target_scope: payload.target_scope ?? null,
      reason: payload.reason ?? null,
    };
  }
}
